import React, { useMemo, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { UsersIcon, CalendarIcon, PrinterIcon, SearchIcon, UserIcon, DoorOpenIcon, ReceiptIcon, ArrowRightFromLineIcon, BanknoteIcon, QrCodeIcon, TicketIcon } from 'lucide-react';
interface UserTransaction {
  id: string;
  date: string;
  gatePassNo: string;
  vehicleNo: string;
  type: 'Gate Entry' | 'Billing' | 'Gate Exit';
  paymentMode: 'Cash' | 'QR' | 'Coupon' | '-';
  amount: number;
}
interface UserData {
  id: string;
  userName: string;
  transactions: UserTransaction[];
}
const allUsers: UserData[] = [{
  id: '1',
  userName: 'Rajesh Kumar',
  transactions: [{
    id: 't1',
    date: '2026-04-02 08:30 AM',
    gatePassNo: 'GP-2026-0001',
    vehicleNo: 'MH-12-AB-1234',
    type: 'Gate Entry',
    paymentMode: '-',
    amount: 0
  }, {
    id: 't2',
    date: '2026-04-02 04:15 PM',
    gatePassNo: 'GP-2026-0001',
    vehicleNo: 'MH-12-AB-1234',
    type: 'Billing',
    paymentMode: 'Cash',
    amount: 350
  }, {
    id: 't3',
    date: '2026-04-02 04:20 PM',
    gatePassNo: 'GP-2026-0001',
    vehicleNo: 'MH-12-AB-1234',
    type: 'Gate Exit',
    paymentMode: '-',
    amount: 0
  }, {
    id: 't4',
    date: '2026-04-05 09:00 AM',
    gatePassNo: 'GP-2026-0010',
    vehicleNo: 'DL-01-GH-3456',
    type: 'Gate Entry',
    paymentMode: '-',
    amount: 0
  }, {
    id: 't5',
    date: '2026-04-05 05:30 PM',
    gatePassNo: 'GP-2026-0010',
    vehicleNo: 'DL-01-GH-3456',
    type: 'Billing',
    paymentMode: 'QR',
    amount: 450
  }, {
    id: 't6',
    date: '2026-04-05 05:35 PM',
    gatePassNo: 'GP-2026-0010',
    vehicleNo: 'DL-01-GH-3456',
    type: 'Gate Exit',
    paymentMode: '-',
    amount: 0
  }, {
    id: 't7',
    date: '2026-04-08 07:45 AM',
    gatePassNo: 'GP-2026-0020',
    vehicleNo: 'RJ-14-IJ-7890',
    type: 'Gate Entry',
    paymentMode: '-',
    amount: 0
  }, {
    id: 't8',
    date: '2026-04-08 03:00 PM',
    gatePassNo: 'GP-2026-0020',
    vehicleNo: 'RJ-14-IJ-7890',
    type: 'Billing',
    paymentMode: 'Coupon',
    amount: 200
  }, {
    id: 't9',
    date: '2026-04-08 03:05 PM',
    gatePassNo: 'GP-2026-0020',
    vehicleNo: 'RJ-14-IJ-7890',
    type: 'Gate Exit',
    paymentMode: '-',
    amount: 0
  }, {
    id: 't10',
    date: '2026-04-10 10:00 AM',
    gatePassNo: 'GP-2026-0030',
    vehicleNo: 'KA-01-KL-2345',
    type: 'Gate Entry',
    paymentMode: '-',
    amount: 0
  }, {
    id: 't11',
    date: '2026-04-10 06:00 PM',
    gatePassNo: 'GP-2026-0030',
    vehicleNo: 'KA-01-KL-2345',
    type: 'Billing',
    paymentMode: 'Cash',
    amount: 150
  }, {
    id: 't12',
    date: '2026-04-10 06:05 PM',
    gatePassNo: 'GP-2026-0030',
    vehicleNo: 'KA-01-KL-2345',
    type: 'Gate Exit',
    paymentMode: '-',
    amount: 0
  }]
}, {
  id: '2',
  userName: 'Priya Sharma',
  transactions: [{
    id: 't13',
    date: '2026-04-01 09:15 AM',
    gatePassNo: 'GP-2026-0002',
    vehicleNo: 'MH-14-CD-5678',
    type: 'Gate Entry',
    paymentMode: '-',
    amount: 0
  }, {
    id: 't14',
    date: '2026-04-01 03:45 PM',
    gatePassNo: 'GP-2026-0002',
    vehicleNo: 'MH-14-CD-5678',
    type: 'Billing',
    paymentMode: 'QR',
    amount: 150
  }, {
    id: 't15',
    date: '2026-04-01 03:50 PM',
    gatePassNo: 'GP-2026-0002',
    vehicleNo: 'MH-14-CD-5678',
    type: 'Gate Exit',
    paymentMode: '-',
    amount: 0
  }, {
    id: 't16',
    date: '2026-04-06 08:00 AM',
    gatePassNo: 'GP-2026-0012',
    vehicleNo: 'GJ-01-AB-1111',
    type: 'Gate Entry',
    paymentMode: '-',
    amount: 0
  }, {
    id: 't17',
    date: '2026-04-06 02:30 PM',
    gatePassNo: 'GP-2026-0012',
    vehicleNo: 'GJ-01-AB-1111',
    type: 'Billing',
    paymentMode: 'Cash',
    amount: 250
  }, {
    id: 't18',
    date: '2026-04-06 02:35 PM',
    gatePassNo: 'GP-2026-0012',
    vehicleNo: 'GJ-01-AB-1111',
    type: 'Gate Exit',
    paymentMode: '-',
    amount: 0
  }, {
    id: 't19',
    date: '2026-04-11 10:30 AM',
    gatePassNo: 'GP-2026-0025',
    vehicleNo: 'UP-32-OP-0123',
    type: 'Gate Entry',
    paymentMode: '-',
    amount: 0
  }, {
    id: 't20',
    date: '2026-04-11 05:00 PM',
    gatePassNo: 'GP-2026-0025',
    vehicleNo: 'UP-32-OP-0123',
    type: 'Billing',
    paymentMode: 'Coupon',
    amount: 350
  }, {
    id: 't21',
    date: '2026-04-11 05:10 PM',
    gatePassNo: 'GP-2026-0025',
    vehicleNo: 'UP-32-OP-0123',
    type: 'Gate Exit',
    paymentMode: '-',
    amount: 0
  }]
}, {
  id: '3',
  userName: 'Amit Patel',
  transactions: [{
    id: 't22',
    date: '2026-04-03 09:45 AM',
    gatePassNo: 'GP-2026-0003',
    vehicleNo: 'GJ-05-EF-9012',
    type: 'Gate Entry',
    paymentMode: '-',
    amount: 0
  }, {
    id: 't23',
    date: '2026-04-03 04:00 PM',
    gatePassNo: 'GP-2026-0003',
    vehicleNo: 'GJ-05-EF-9012',
    type: 'Billing',
    paymentMode: 'Cash',
    amount: 250
  }, {
    id: 't24',
    date: '2026-04-03 04:05 PM',
    gatePassNo: 'GP-2026-0003',
    vehicleNo: 'GJ-05-EF-9012',
    type: 'Gate Exit',
    paymentMode: '-',
    amount: 0
  }, {
    id: 't25',
    date: '2026-04-07 11:00 AM',
    gatePassNo: 'GP-2026-0015',
    vehicleNo: 'TN-09-MN-6789',
    type: 'Gate Entry',
    paymentMode: '-',
    amount: 0
  }, {
    id: 't26',
    date: '2026-04-07 06:30 PM',
    gatePassNo: 'GP-2026-0015',
    vehicleNo: 'TN-09-MN-6789',
    type: 'Billing',
    paymentMode: 'QR',
    amount: 70
  }, {
    id: 't27',
    date: '2026-04-07 06:35 PM',
    gatePassNo: 'GP-2026-0015',
    vehicleNo: 'TN-09-MN-6789',
    type: 'Gate Exit',
    paymentMode: '-',
    amount: 0
  }, {
    id: 't28',
    date: '2026-04-12 08:15 AM',
    gatePassNo: 'GP-2026-0035',
    vehicleNo: 'HR-26-ST-8901',
    type: 'Gate Entry',
    paymentMode: '-',
    amount: 0
  }, {
    id: 't29',
    date: '2026-04-12 01:45 PM',
    gatePassNo: 'GP-2026-0035',
    vehicleNo: 'HR-26-ST-8901',
    type: 'Billing',
    paymentMode: 'Cash',
    amount: 450
  }, {
    id: 't30',
    date: '2026-04-12 01:50 PM',
    gatePassNo: 'GP-2026-0035',
    vehicleNo: 'HR-26-ST-8901',
    type: 'Gate Exit',
    paymentMode: '-',
    amount: 0
  }, {
    id: 't31',
    date: '2026-04-14 09:00 AM',
    gatePassNo: 'GP-2026-0040',
    vehicleNo: 'MP-09-QR-4567',
    type: 'Gate Entry',
    paymentMode: '-',
    amount: 0
  }, {
    id: 't32',
    date: '2026-04-14 04:30 PM',
    gatePassNo: 'GP-2026-0040',
    vehicleNo: 'MP-09-QR-4567',
    type: 'Billing',
    paymentMode: 'QR',
    amount: 250
  }, {
    id: 't33',
    date: '2026-04-14 04:35 PM',
    gatePassNo: 'GP-2026-0040',
    vehicleNo: 'MP-09-QR-4567',
    type: 'Gate Exit',
    paymentMode: '-',
    amount: 0
  }]
}, {
  id: '4',
  userName: 'Sunil Verma',
  transactions: [{
    id: 't34',
    date: '2026-04-04 10:00 AM',
    gatePassNo: 'GP-2026-0004',
    vehicleNo: 'DL-01-GH-3456',
    type: 'Gate Entry',
    paymentMode: '-',
    amount: 0
  }, {
    id: 't35',
    date: '2026-04-04 05:00 PM',
    gatePassNo: 'GP-2026-0004',
    vehicleNo: 'DL-01-GH-3456',
    type: 'Billing',
    paymentMode: 'Coupon',
    amount: 450
  }, {
    id: 't36',
    date: '2026-04-04 05:05 PM',
    gatePassNo: 'GP-2026-0004',
    vehicleNo: 'DL-01-GH-3456',
    type: 'Gate Exit',
    paymentMode: '-',
    amount: 0
  }, {
    id: 't37',
    date: '2026-04-09 08:30 AM',
    gatePassNo: 'GP-2026-0018',
    vehicleNo: 'MH-12-XY-9999',
    type: 'Gate Entry',
    paymentMode: '-',
    amount: 0
  }, {
    id: 't38',
    date: '2026-04-09 03:15 PM',
    gatePassNo: 'GP-2026-0018',
    vehicleNo: 'MH-12-XY-9999',
    type: 'Billing',
    paymentMode: 'Cash',
    amount: 350
  }, {
    id: 't39',
    date: '2026-04-09 03:20 PM',
    gatePassNo: 'GP-2026-0018',
    vehicleNo: 'MH-12-XY-9999',
    type: 'Gate Exit',
    paymentMode: '-',
    amount: 0
  }]
}, {
  id: '5',
  userName: 'Deepak Singh',
  transactions: [{
    id: 't40',
    date: '2026-04-02 10:30 AM',
    gatePassNo: 'GP-2026-0005',
    vehicleNo: 'RJ-14-IJ-7890',
    type: 'Gate Entry',
    paymentMode: '-',
    amount: 0
  }, {
    id: 't41',
    date: '2026-04-02 06:00 PM',
    gatePassNo: 'GP-2026-0005',
    vehicleNo: 'RJ-14-IJ-7890',
    type: 'Billing',
    paymentMode: 'Cash',
    amount: 350
  }, {
    id: 't42',
    date: '2026-04-02 06:05 PM',
    gatePassNo: 'GP-2026-0005',
    vehicleNo: 'RJ-14-IJ-7890',
    type: 'Gate Exit',
    paymentMode: '-',
    amount: 0
  }, {
    id: 't43',
    date: '2026-04-13 07:00 AM',
    gatePassNo: 'GP-2026-0038',
    vehicleNo: 'KA-01-KL-2345',
    type: 'Gate Entry',
    paymentMode: '-',
    amount: 0
  }, {
    id: 't44',
    date: '2026-04-13 02:00 PM',
    gatePassNo: 'GP-2026-0038',
    vehicleNo: 'KA-01-KL-2345',
    type: 'Billing',
    paymentMode: 'QR',
    amount: 150
  }, {
    id: 't45',
    date: '2026-04-13 02:05 PM',
    gatePassNo: 'GP-2026-0038',
    vehicleNo: 'KA-01-KL-2345',
    type: 'Gate Exit',
    paymentMode: '-',
    amount: 0
  }]
}, {
  id: '6',
  userName: 'Meena Reddy',
  transactions: [{
    id: 't46',
    date: '2026-04-03 11:00 AM',
    gatePassNo: 'GP-2026-0006',
    vehicleNo: 'KA-01-KL-2345',
    type: 'Gate Entry',
    paymentMode: '-',
    amount: 0
  }, {
    id: 't47',
    date: '2026-04-03 05:30 PM',
    gatePassNo: 'GP-2026-0006',
    vehicleNo: 'KA-01-KL-2345',
    type: 'Billing',
    paymentMode: 'QR',
    amount: 150
  }, {
    id: 't48',
    date: '2026-04-03 05:35 PM',
    gatePassNo: 'GP-2026-0006',
    vehicleNo: 'KA-01-KL-2345',
    type: 'Gate Exit',
    paymentMode: '-',
    amount: 0
  }]
}];
const typeBadge: Record<string, {
  bg: string;
  text: string;
}> = {
  'Gate Entry': {
    bg: 'bg-blue-50 text-blue-700',
    text: 'text-blue-700'
  },
  Billing: {
    bg: 'bg-amber-50 text-amber-700',
    text: 'text-amber-700'
  },
  'Gate Exit': {
    bg: 'bg-green-50 text-green-700',
    text: 'text-green-700'
  }
};
const paymentBadge: Record<string, {
  bg: string;
  text: string;
}> = {
  Cash: {
    bg: 'bg-emerald-50 text-emerald-700',
    text: 'text-emerald-700'
  },
  QR: {
    bg: 'bg-violet-50 text-violet-700',
    text: 'text-violet-700'
  },
  Coupon: {
    bg: 'bg-orange-50 text-orange-700',
    text: 'text-orange-700'
  }
};
export function UserReportPage() {
  const [selectedUserId, setSelectedUserId] = useState('');
  const [startDate, setStartDate] = useState('2026-04-01');
  const [endDate, setEndDate] = useState('2026-04-15');
  const [hasGenerated, setHasGenerated] = useState(false);
  const selectedUser = allUsers.find(u => u.id === selectedUserId) || null;
  const summary = useMemo(() => {
    if (!selectedUser) return null;
    const txns = selectedUser.transactions;
    const gateEntries = txns.filter(t => t.type === 'Gate Entry').length;
    const billing = txns.filter(t => t.type === 'Billing').length;
    const gateExits = txns.filter(t => t.type === 'Gate Exit').length;
    const cashTxns = txns.filter(t => t.paymentMode === 'Cash');
    const qrTxns = txns.filter(t => t.paymentMode === 'QR');
    const couponTxns = txns.filter(t => t.paymentMode === 'Coupon');
    return {
      gateEntries,
      billing,
      gateExits,
      cashCount: cashTxns.length,
      cashAmount: cashTxns.reduce((s, t) => s + t.amount, 0),
      qrCount: qrTxns.length,
      qrAmount: qrTxns.reduce((s, t) => s + t.amount, 0),
      couponCount: couponTxns.length,
      couponAmount: couponTxns.reduce((s, t) => s + t.amount, 0),
      totalAmount: txns.reduce((s, t) => s + t.amount, 0)
    };
  }, [selectedUser]);
  const handleGenerate = () => {
    if (!selectedUserId) return;
    setHasGenerated(true);
  };
  const handlePrint = () => {
    document.body.classList.add('print-a4');
    window.print();
    document.body.classList.remove('print-a4');
  };
  return <div className="w-full max-w-6xl mx-auto" data-id="element-1285">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="bg-white rounded-2xl shadow-xl shadow-slate-200/50 border border-slate-100 p-5 xs:p-6 sm:p-8 no-print" data-id="element-1286">
        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6" data-id="element-1287">
          <div className="flex items-center gap-3" data-id="element-1288">
            <div className="bg-brand-teal/10 p-2 rounded-xl border border-brand-teal/20" data-id="element-1289">
              <UsersIcon className="w-6 h-6 text-brand-teal" data-id="element-1290" />
            </div>
            <div data-id="element-1291">
              <h2 className="text-xl sm:text-2xl font-bold text-slate-900 tracking-tight" data-id="element-1292">
                User Report
              </h2>
              <p className="text-sm text-slate-500" data-id="element-1293">
                Select a user to view their activity and payment details.
              </p>
            </div>
          </div>
          {hasGenerated && selectedUser && <button onClick={handlePrint} className="inline-flex items-center justify-center gap-2 bg-brand-teal text-white px-4 py-2.5 rounded-xl font-medium text-sm hover:bg-brand-tealHover transition-colors" data-id="element-1294">
              <PrinterIcon className="w-4 h-4" data-id="element-1295" />
              Print Report
            </button>}
        </div>

        {/* Filters */}
        <div className="flex flex-col sm:flex-row gap-4 mb-8 p-4 bg-slate-50 rounded-xl border border-slate-200" data-id="element-1296">
          <div className="flex-1" data-id="element-1297">
            <label className="block text-xs font-semibold text-slate-500 mb-1.5" data-id="element-1298">
              Select User
            </label>
            <div className="relative" data-id="element-1299">
              <UserIcon className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4.5 h-4.5 text-slate-400 pointer-events-none" data-id="element-1300" />
              <select value={selectedUserId} onChange={e => {
              setSelectedUserId(e.target.value);
              setHasGenerated(false);
            }} className="w-full pl-10 pr-4 py-2.5 rounded-xl border border-slate-200 bg-white text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-brand-teal/30 focus:border-brand-teal transition-all appearance-none" data-id="element-1301">
                <option value="" data-id="element-1302">-- Select User --</option>
                {allUsers.map(u => <option key={u.id} value={u.id} data-id="element-1303">
                    {u.userName}
                  </option>)}
              </select>
            </div>
          </div>
          <div className="flex-1" data-id="element-1304">
            <label className="block text-xs font-semibold text-slate-500 mb-1.5" data-id="element-1305">
              Start Date
            </label>
            <div className="relative" data-id="element-1306">
              <CalendarIcon className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4.5 h-4.5 text-slate-400 pointer-events-none" data-id="element-1307" />
              <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} className="w-full pl-10 pr-4 py-2.5 rounded-xl border border-slate-200 bg-white text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-brand-teal/30 focus:border-brand-teal transition-all" data-id="element-1308" />
            </div>
          </div>
          <div className="flex-1" data-id="element-1309">
            <label className="block text-xs font-semibold text-slate-500 mb-1.5" data-id="element-1310">
              End Date
            </label>
            <div className="relative" data-id="element-1311">
              <CalendarIcon className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4.5 h-4.5 text-slate-400 pointer-events-none" data-id="element-1312" />
              <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} className="w-full pl-10 pr-4 py-2.5 rounded-xl border border-slate-200 bg-white text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-brand-teal/30 focus:border-brand-teal transition-all" data-id="element-1313" />
            </div>
          </div>
          <div className="flex items-end" data-id="element-1314">
            <button onClick={handleGenerate} disabled={!selectedUserId} className="w-full sm:w-auto px-6 py-2.5 bg-slate-800 text-white rounded-xl font-medium text-sm hover:bg-slate-700 transition-colors flex items-center justify-center gap-2 h-[42px] disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-1315">
              <SearchIcon className="w-4 h-4" data-id="element-1316" />
              Generate
            </button>
          </div>
        </div>

        {/* Report Content */}
        <AnimatePresence mode="wait" data-id="element-1317">
          {hasGenerated && selectedUser && summary && <motion.div key="report" initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -10
        }} data-id="element-1318">
              {/* User Info */}
              <div className="flex items-center gap-3 mb-6 pb-4 border-b border-slate-200" data-id="element-1319">
                <div className="w-10 h-10 rounded-full bg-brand-teal/10 flex items-center justify-center" data-id="element-1320">
                  <UserIcon className="w-5 h-5 text-brand-teal" data-id="element-1321" />
                </div>
                <div data-id="element-1322">
                  <h3 className="text-lg font-bold text-slate-900" data-id="element-1323">
                    {selectedUser.userName}
                  </h3>
                  <p className="text-xs text-slate-500" data-id="element-1324">
                    Report Period: {startDate} to {endDate}
                  </p>
                </div>
              </div>

              {/* Summary Cards */}
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 mb-6" data-id="element-1325">
                <div className="bg-blue-50 rounded-xl p-3 border border-blue-100" data-id="element-1326">
                  <div className="flex items-center gap-2 mb-1" data-id="element-1327">
                    <DoorOpenIcon className="w-4 h-4 text-blue-600" data-id="element-1328" />
                    <span className="text-xs font-semibold text-blue-600" data-id="element-1329">
                      Gate Entries
                    </span>
                  </div>
                  <p className="text-2xl font-bold text-blue-800" data-id="element-1330">
                    {summary.gateEntries}
                  </p>
                </div>
                <div className="bg-amber-50 rounded-xl p-3 border border-amber-100" data-id="element-1331">
                  <div className="flex items-center gap-2 mb-1" data-id="element-1332">
                    <ReceiptIcon className="w-4 h-4 text-amber-600" data-id="element-1333" />
                    <span className="text-xs font-semibold text-amber-600" data-id="element-1334">
                      Billing
                    </span>
                  </div>
                  <p className="text-2xl font-bold text-amber-800" data-id="element-1335">
                    {summary.billing}
                  </p>
                </div>
                <div className="bg-green-50 rounded-xl p-3 border border-green-100" data-id="element-1336">
                  <div className="flex items-center gap-2 mb-1" data-id="element-1337">
                    <ArrowRightFromLineIcon className="w-4 h-4 text-green-600" data-id="element-1338" />
                    <span className="text-xs font-semibold text-green-600" data-id="element-1339">
                      Gate Exits
                    </span>
                  </div>
                  <p className="text-2xl font-bold text-green-800" data-id="element-1340">
                    {summary.gateExits}
                  </p>
                </div>
                <div className="bg-emerald-50 rounded-xl p-3 border border-emerald-100" data-id="element-1341">
                  <div className="flex items-center gap-2 mb-1" data-id="element-1342">
                    <BanknoteIcon className="w-4 h-4 text-emerald-600" data-id="element-1343" />
                    <span className="text-xs font-semibold text-emerald-600" data-id="element-1344">
                      Cash ({summary.cashCount})
                    </span>
                  </div>
                  <p className="text-2xl font-bold text-emerald-800" data-id="element-1345">
                    ₹{summary.cashAmount.toLocaleString()}
                  </p>
                </div>
                <div className="bg-violet-50 rounded-xl p-3 border border-violet-100" data-id="element-1346">
                  <div className="flex items-center gap-2 mb-1" data-id="element-1347">
                    <QrCodeIcon className="w-4 h-4 text-violet-600" data-id="element-1348" />
                    <span className="text-xs font-semibold text-violet-600" data-id="element-1349">
                      QR ({summary.qrCount})
                    </span>
                  </div>
                  <p className="text-2xl font-bold text-violet-800" data-id="element-1350">
                    ₹{summary.qrAmount.toLocaleString()}
                  </p>
                </div>
                <div className="bg-orange-50 rounded-xl p-3 border border-orange-100" data-id="element-1351">
                  <div className="flex items-center gap-2 mb-1" data-id="element-1352">
                    <TicketIcon className="w-4 h-4 text-orange-600" data-id="element-1353" />
                    <span className="text-xs font-semibold text-orange-600" data-id="element-1354">
                      Coupon ({summary.couponCount})
                    </span>
                  </div>
                  <p className="text-2xl font-bold text-orange-800" data-id="element-1355">
                    ₹{summary.couponAmount.toLocaleString()}
                  </p>
                </div>
              </div>

              {/* Total Amount */}
              <div className="flex items-center justify-between p-4 bg-slate-50 rounded-xl border border-slate-200 mb-6" data-id="element-1356">
                <span className="font-bold text-slate-700" data-id="element-1357">
                  Total Collection
                </span>
                <span className="text-xl font-bold text-brand-teal" data-id="element-1358">
                  ₹{summary.totalAmount.toLocaleString()}
                </span>
              </div>

              {/* Transaction Details Table */}
              <div className="border border-slate-200 rounded-xl overflow-hidden" data-id="element-1359">
                <div className="bg-slate-50 px-4 py-3 border-b border-slate-200" data-id="element-1360">
                  <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider" data-id="element-1361">
                    Transaction Details
                  </p>
                </div>
                <div className="overflow-x-auto" data-id="element-1362">
                  <table className="w-full text-left text-sm whitespace-nowrap" data-id="element-1363">
                    <thead className="bg-slate-50 border-b border-slate-200 text-slate-500" data-id="element-1364">
                      <tr data-id="element-1365">
                        <th className="px-4 py-3 font-semibold" data-id="element-1366">Date & Time</th>
                        <th className="px-4 py-3 font-semibold" data-id="element-1367">
                          Gate Pass No.
                        </th>
                        <th className="px-4 py-3 font-semibold" data-id="element-1368">Vehicle No.</th>
                        <th className="px-4 py-3 font-semibold" data-id="element-1369">Activity</th>
                        <th className="px-4 py-3 font-semibold" data-id="element-1370">
                          Payment Mode
                        </th>
                        <th className="px-4 py-3 font-semibold text-right" data-id="element-1371">
                          Amount (₹)
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-100" data-id="element-1372">
                      {selectedUser.transactions.map(txn => <tr key={txn.id} className="hover:bg-slate-50/50 transition-colors" data-id="element-1373">
                          <td className="px-4 py-3 text-slate-600 text-xs" data-id="element-1374">
                            {txn.date}
                          </td>
                          <td className="px-4 py-3 font-mono text-slate-700 font-medium text-xs" data-id="element-1375">
                            {txn.gatePassNo}
                          </td>
                          <td className="px-4 py-3 font-mono text-slate-900 font-bold text-xs" data-id="element-1376">
                            {txn.vehicleNo}
                          </td>
                          <td className="px-4 py-3" data-id="element-1377">
                            <span className={`inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium ${typeBadge[txn.type]?.bg || ''}`} data-id="element-1378">
                              {txn.type}
                            </span>
                          </td>
                          <td className="px-4 py-3" data-id="element-1379">
                            {txn.paymentMode !== '-' ? <span className={`inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium ${paymentBadge[txn.paymentMode]?.bg || ''}`} data-id="element-1380">
                                {txn.paymentMode}
                              </span> : <span className="text-slate-300 text-xs" data-id="element-1381">—</span>}
                          </td>
                          <td className="px-4 py-3 text-right font-medium text-slate-700" data-id="element-1382">
                            {txn.amount > 0 ? `₹${txn.amount.toFixed(2)}` : <span className="text-slate-300" data-id="element-1383">—</span>}
                          </td>
                        </tr>)}
                    </tbody>
                    <tfoot className="bg-slate-50 border-t border-slate-200 font-bold text-slate-900" data-id="element-1384">
                      <tr data-id="element-1385">
                        <td colSpan={5} className="px-4 py-3 text-right" data-id="element-1386">
                          Total:
                        </td>
                        <td className="px-4 py-3 text-right text-brand-teal" data-id="element-1387">
                          ₹{summary.totalAmount.toFixed(2)}
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </motion.div>}

          {!hasGenerated && <motion.div key="empty" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} className="border-2 border-dashed border-slate-200 rounded-xl p-8 text-center bg-slate-50" data-id="element-1388">
              <UserIcon className="w-10 h-10 text-slate-300 mx-auto mb-3" data-id="element-1389" />
              <p className="text-slate-500 text-sm font-medium" data-id="element-1390">
                Select a user and date range to generate report
              </p>
            </motion.div>}
        </AnimatePresence>
      </motion.div>

      {/* Print Only Layout */}
      {hasGenerated && selectedUser && summary && <div id="print-a4-report" className="hidden print:block bg-white text-black p-8" data-id="element-1391">
          {/* Print Header */}
          <div className="text-center mb-6 border-b-2 border-black pb-4" data-id="element-1392">
            <h1 className="text-2xl font-bold tracking-tight mb-1" data-id="element-1393">
              ERPLogiPark
            </h1>
            <p className="text-sm text-gray-600 mb-3" data-id="element-1394">
              Plot No. 45, Logistics Hub, Sector 18, Industrial Area, Bangalore
              - 560100
            </p>
            <h2 className="text-xl font-bold uppercase tracking-wider mb-1" data-id="element-1395">
              User Activity Report
            </h2>
            <p className="text-sm font-medium" data-id="element-1396">User: {selectedUser.userName}</p>
            <p className="text-sm" data-id="element-1397">
              Period: {startDate} to {endDate}
            </p>
          </div>

          {/* Print Summary */}
          <div className="mb-6" data-id="element-1398">
            <h3 className="text-sm font-bold uppercase border-b border-gray-400 pb-1 mb-3" data-id="element-1399">
              Summary
            </h3>
            <table className="w-full text-sm border-collapse mb-2" data-id="element-1400">
              <tbody data-id="element-1401">
                <tr data-id="element-1402">
                  <td className="py-1 pr-4 text-gray-600" data-id="element-1403">Gate Entries:</td>
                  <td className="py-1 font-bold" data-id="element-1404">{summary.gateEntries}</td>
                  <td className="py-1 pr-4 text-gray-600 pl-8" data-id="element-1405">Billing:</td>
                  <td className="py-1 font-bold" data-id="element-1406">{summary.billing}</td>
                  <td className="py-1 pr-4 text-gray-600 pl-8" data-id="element-1407">Gate Exits:</td>
                  <td className="py-1 font-bold" data-id="element-1408">{summary.gateExits}</td>
                </tr>
              </tbody>
            </table>
            <table className="w-full text-sm border-collapse" data-id="element-1409">
              <thead data-id="element-1410">
                <tr className="border-b border-gray-300" data-id="element-1411">
                  <th className="py-1 text-left font-bold" data-id="element-1412">Payment Mode</th>
                  <th className="py-1 text-center font-bold" data-id="element-1413">Count</th>
                  <th className="py-1 text-right font-bold" data-id="element-1414">Amount (₹)</th>
                </tr>
              </thead>
              <tbody data-id="element-1415">
                <tr className="border-b border-gray-200" data-id="element-1416">
                  <td className="py-1" data-id="element-1417">Cash</td>
                  <td className="py-1 text-center" data-id="element-1418">{summary.cashCount}</td>
                  <td className="py-1 text-right" data-id="element-1419">
                    {summary.cashAmount.toFixed(2)}
                  </td>
                </tr>
                <tr className="border-b border-gray-200" data-id="element-1420">
                  <td className="py-1" data-id="element-1421">QR</td>
                  <td className="py-1 text-center" data-id="element-1422">{summary.qrCount}</td>
                  <td className="py-1 text-right" data-id="element-1423">
                    {summary.qrAmount.toFixed(2)}
                  </td>
                </tr>
                <tr className="border-b border-gray-200" data-id="element-1424">
                  <td className="py-1" data-id="element-1425">Coupon</td>
                  <td className="py-1 text-center" data-id="element-1426">{summary.couponCount}</td>
                  <td className="py-1 text-right" data-id="element-1427">
                    {summary.couponAmount.toFixed(2)}
                  </td>
                </tr>
                <tr className="border-t-2 border-black font-bold" data-id="element-1428">
                  <td className="py-1" data-id="element-1429">Total</td>
                  <td className="py-1 text-center" data-id="element-1430">
                    {summary.cashCount + summary.qrCount + summary.couponCount}
                  </td>
                  <td className="py-1 text-right" data-id="element-1431">
                    {summary.totalAmount.toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Print Transaction Table */}
          <h3 className="text-sm font-bold uppercase border-b border-gray-400 pb-1 mb-3" data-id="element-1432">
            Transaction Details
          </h3>
          <table className="w-full text-left text-xs border-collapse" data-id="element-1433">
            <thead data-id="element-1434">
              <tr className="border-b-2 border-black" data-id="element-1435">
                <th className="py-2 pr-2 font-bold" data-id="element-1436">Date & Time</th>
                <th className="py-2 px-2 font-bold" data-id="element-1437">Gate Pass</th>
                <th className="py-2 px-2 font-bold" data-id="element-1438">Vehicle No.</th>
                <th className="py-2 px-2 font-bold" data-id="element-1439">Activity</th>
                <th className="py-2 px-2 font-bold" data-id="element-1440">Payment</th>
                <th className="py-2 pl-2 font-bold text-right" data-id="element-1441">Amount (₹)</th>
              </tr>
            </thead>
            <tbody data-id="element-1442">
              {selectedUser.transactions.map((txn, index) => <tr key={txn.id} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} data-id="element-1443">
                  <td className="py-1.5 pr-2 border-b border-gray-200" data-id="element-1444">
                    {txn.date}
                  </td>
                  <td className="py-1.5 px-2 border-b border-gray-200 font-mono" data-id="element-1445">
                    {txn.gatePassNo}
                  </td>
                  <td className="py-1.5 px-2 border-b border-gray-200 font-mono font-bold" data-id="element-1446">
                    {txn.vehicleNo}
                  </td>
                  <td className="py-1.5 px-2 border-b border-gray-200" data-id="element-1447">
                    {txn.type}
                  </td>
                  <td className="py-1.5 px-2 border-b border-gray-200" data-id="element-1448">
                    {txn.paymentMode}
                  </td>
                  <td className="py-1.5 pl-2 border-b border-gray-200 text-right" data-id="element-1449">
                    {txn.amount > 0 ? txn.amount.toFixed(2) : '—'}
                  </td>
                </tr>)}
            </tbody>
            <tfoot data-id="element-1450">
              <tr className="border-t-2 border-black font-bold" data-id="element-1451">
                <td colSpan={5} className="py-2 text-right" data-id="element-1452">
                  TOTAL:
                </td>
                <td className="py-2 pl-2 text-right" data-id="element-1453">
                  {summary.totalAmount.toFixed(2)}
                </td>
              </tr>
            </tfoot>
          </table>

          {/* Print Footer */}
          <div className="mt-12 text-xs text-gray-500 flex justify-between" data-id="element-1454">
            <p data-id="element-1455">Generated on: {new Date().toLocaleString()}</p>
            <p data-id="element-1456">Page 1 of 1</p>
          </div>
        </div>}
    </div>;
}